// Collapses per-channel rtsp_paths into a ``.format(channel)`` template; null when
// no replacement position round-trips on the second channel. Leading "/" enforced.
export default function deriveRtspUrlSuffixTemplate(channelRows) {
  if (!Array.isArray(channelRows)) return null;
  const samples = channelRows
    .map((row) => ({
      channel: Number(row?.channel),
      path: row?.main?.rtsp_path,
    }))
    .filter((s) => Number.isInteger(s.channel) && s.channel >= 1 && typeof s.path === "string" && s.path.length > 0);
  if (samples.length < 2) return null;
  samples.sort((a, b) => a.channel - b.channel);
  const [a, b] = samples;
  const aChStr = String(a.channel);
  const bChStr = String(b.channel);

  for (let idx = 0; idx <= a.path.length - aChStr.length; idx += 1) {
    if (a.path.substr(idx, aChStr.length) !== aChStr) continue;
    const template = `${a.path.slice(0, idx)}{}${a.path.slice(idx + aChStr.length)}`;
    const predicted = template.replace("{}", bChStr);
    if (predicted === b.path) {
      return template.startsWith("/") ? template : `/${template}`;
    }
  }
  return null;
}
